<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <h1 class="text-center">Deals iframe</h1>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
